function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg from 'ha/ui/next/SvgIcon';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.793.249L4.322 11.233a1.066 1.066 0 0 0 0 1.539l12.471 10.979a.987.987 0 0 0 1.414-.107l1.557-1.85a1.028 1.028 0 0 0-.111-1.438L10.2 12.191a.25.25 0 0 1 0-.379l9.45-8.168a1.021 1.021 0 0 0 .349-.7 1 1 0 0 0-.238-.741L18.207.356A.988.988 0 0 0 17.522 0a.978.978 0 0 0-.729.249z"
});

var SvgArrowButtonLeftBold = function SvgArrowButtonLeftBold(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgArrowButtonLeftBold;